//# Various Newsletter elements on the site
const comp_newsletter = document.getElementById("comp-newsletter");
const footer_newsletter = document.getElementById("footer_form");
const media_newsletter = document.getElementById("media-newsletter");


//# Posting Status
let isPostingNewsletter = false;


//# If user is using the form on the newsletter component
if (comp_newsletter) {
  const newsletter_form = comp_newsletter.querySelector("form");
  const newsletter_input = comp_newsletter.querySelector("input");
  const newsletter_response = comp_newsletter.querySelector(".response");
  const btn_sumbit = comp_newsletter.querySelector("button");

  btn_sumbit.onclick = (e) => {
    e.preventDefault();
    submit_newsletter(newsletter_form, newsletter_input, newsletter_response );
  };
}

//# If user user newsletter form on footer
if (footer_newsletter) {
  const newsletter_form = footer_newsletter.querySelector("form");
  const newsletter_input = footer_newsletter.querySelector("input");
  const newsletter_response = footer_newsletter.querySelector(".response");
  const btn_sumbit = footer_newsletter.querySelector("button");

  btn_sumbit.onclick = (e) => {
    e.preventDefault();
    submit_newsletter(newsletter_form, newsletter_input, newsletter_response );
  };
}

//# If user is on the newsletter form on the media page
if (media_newsletter) {
  const newsletter_form = media_newsletter.querySelector("form");
  const newsletter_input = media_newsletter.querySelector("input");
  const newsletter_response = media_newsletter.querySelector(".response");
  const btn_sumbit = media_newsletter.querySelector("button");

  btn_sumbit.onclick = (e) => {
    e.preventDefault();
    submit_newsletter(newsletter_form, newsletter_input, newsletter_response );
  };
}



//# Function to subscribe to the newsletter from any of the newsletter form sections
async function submit_newsletter(
  newsletter_form,
  newsletter_input,
  newsletter_response
) {
  //% Exit function if already busy posting
  if (isPostingNewsletter) {
    return;
  }

  //% Clear response message
  newsletter_response.innerText = "";

  //% Form data and AJAX options
  const formData = new FormData(newsletter_form);
  const url =
    window.origin + "/wp-json/contact-form-7/v1/contact-forms/67/feedback";
  const options = {
    method: "POST",
    body: formData,
  };


  try {
    //% Set posting status on elements
    isPostingNewsletter = true;
    newsletter_form.classList.add("busy");
    newsletter_response.innerText = "Submitting...";

    const request = await fetch(url, options);
    // console.log(request);

    //% Throw error message is request fails
    if (!request.ok) {
      throw new Error(
        "Request has faileed with status code: " +
          request.status +
          " - " +
          request.statusText
      );
    }

    const response = await request.json();
    // console.log(response);

    //% Set response message
    newsletter_response.innerText = response.message;

    //% If request was successful, clear input fields and set response message
    if (response.status === "mail_sent") {
      //$ Clear inputs
      newsletter_input.value = "";
    }

  } catch (error) {
    console.log(error);
  }

  //% Reset posting status
  isPostingNewsletter = false;
  newsletter_form.classList.remove("busy");
}
